import { buildProps, definePropType } from '../../../utils/vue/props/runtime.mjs';

const autoResizerProps = buildProps({
  disableWidth: Boolean,
  disableHeight: Boolean,
  onResize: {
    type: definePropType(Function)
  }
});

export { autoResizerProps };
//# sourceMappingURL=auto-resizer.mjs.map
